import { put, select } from 'redux-saga/effects'
import { takeLatest } from '@redux-saga/core/effects'
import { getQuickActionsSelector } from '../selectors/quickActions.selector'
import { setAddVentilatorToTimeline } from '../store/quickActions.actions'
import { resetState } from '../../procedures/ventilator/store/ventilator.actions'
import { addVentilatorItem } from '../../timeline/store/timeline.actions'
import { VentilatorConstants } from '../../procedures/ventilator/store/ventilator.constants'

export function* saveVentilatorQuickActionTimeLineRow() {
  const quickActionsObject = yield select(getQuickActionsSelector)
  const { addVentilatorToTimeline } = quickActionsObject
  if (addVentilatorToTimeline) {
    yield put(addVentilatorItem())
    yield put(setAddVentilatorToTimeline(false))
    yield put(resetState())
  }
}

export function* saveVentilatorQuickActionTimeLineRowSaga() {
  yield takeLatest([VentilatorConstants.SET_ADD_TO_TIMELINE], saveVentilatorQuickActionTimeLineRow)
}
